module.exports = __webpack_public_path__ + "public/images/captcha-triangle.9f4bfc2ee91bf15a64cb836132d03d55.svg";